/**
 * @fileoverview Task colour palette helpers (MOR-696)
 *
 * The firm-defined task statuses + labels draw their colour from the shadcn
 * `Badge` palette (`taskColorValidator` in convex/lib/taskColor.schema.ts).
 * These helpers give the settings pickers, side panel, and calendar surface
 * one shared source for the colour list and the swatch dot classes.
 *
 * Tailwind needs literal class names, so the swatch classes are spelled out
 * per colour rather than interpolated.
 */

import type { TaskColor } from "@cvx/lib/taskColor.schema";

/** Ordered colour options shown in the swatch picker. */
export const TASK_COLORS: ReadonlyArray<TaskColor> = [
  "gray",
  "blue",
  "sky",
  "teal",
  "green",
  "emerald",
  "amber",
  "orange",
  "red",
  "pink",
  "purple",
  "violet",
  "indigo",
];

/** Solid swatch background for a colour dot. */
export const TASK_COLOR_DOT: Record<TaskColor, string> = {
  gray: "bg-gray-500",
  blue: "bg-blue-500",
  sky: "bg-sky-500",
  teal: "bg-teal-500",
  green: "bg-green-500",
  emerald: "bg-emerald-500",
  amber: "bg-amber-500",
  orange: "bg-orange-500",
  red: "bg-red-500",
  pink: "bg-pink-500",
  purple: "bg-purple-500",
  violet: "bg-violet-500",
  indigo: "bg-indigo-500",
};

/** Human label for a colour token (Title Case). */
export function taskColorLabel(color: TaskColor): string {
  return color.charAt(0).toUpperCase() + color.slice(1);
}
